angular.module('leanlaw').directive('dataRangeSelection', [() => ({
  restrict: 'EA',
  scope: {
    ngClick: '&'
  },
  template: require('./views/dateRangeSelection.html'),
  controller: ['$scope', function ($scope) {
    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    $scope.vm = {
      dateRangeOptions: [{
        id: 'thisMonth',
        label: monthString(today.getMonth())
      }, {
        id: 'lastMonth',
        label: monthString(lastMonth.getMonth())
      }, {
        id: 'thisYear',
        label: 'YTD'
      }]
    };
    $scope.selected = $dateRange => {
      $scope.ngClick({
        $dateRange
      });
    };
    function monthString(month) {
      return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][month];
    }
  }]
})]);